module.exports = __webpack_public_path__ + "img/wom2025_partners.ce3ec3de.jpg";